import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ArtPopoverPageRoutingModule } from './art-popover-routing.module';

import { ArtPopoverPage } from './art-popover.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ArtPopoverPageRoutingModule
  ],
  declarations: [ArtPopoverPage]
})
export class ArtPopoverPageModule {}
